import React from 'react';
import { AlertTriangleIcon, TrendingDownIcon, DollarSignIcon } from 'lucide-react';
export function ConspiracySection() {
  return <section className="py-16 bg-gray-100" data-id="element-54">
      <div className="container mx-auto px-4" data-id="element-55">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 font-serif" data-id="element-56">
          THE CONSPIRACY REVEALED
        </h2>
        <div className="max-w-4xl mx-auto" data-id="element-57">
          <div className="mb-16" data-id="element-58">
            <h3 className="text-2xl font-bold mb-6 flex items-center" data-id="element-59">
              <AlertTriangleIcon className="mr-3 text-blue-600" size={28} data-id="element-60" />
              The Testosterone Crisis They Don't Want You to Notice
            </h3>
            <div className="flex flex-col md:flex-row gap-8 mb-6" data-id="element-61">
              <div className="md:w-1/2" data-id="element-62">
                <p className="mb-4 text-lg" data-id="element-63">
                  Here's a fact that should terrify every man reading this:
                </p>
                <p className="text-xl font-bold mb-4 text-center py-3 bg-blue-600 text-white" data-id="element-64">
                  Testosterone levels have been dropping by 1% every single year
                  since the 1980s.
                </p>
                <p className="mb-4" data-id="element-65">
                  That means if you're 45 today, you have 20-30% less
                  testosterone than your father had at your age. And your son
                  will have even less than you.
                </p>
                <p className="mb-4" data-id="element-66">
                  This isn't "normal aging." This is systematic poisoning.
                </p>
              </div>
              <div className="md:w-1/2" data-id="element-67">
                <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Declining testosterone chart" className="rounded-lg shadow-md w-full h-auto" data-id="element-68" />
              </div>
            </div>
            <p className="mb-4" data-id="element-69">
              The culprits? The same processed foods, endocrine-disrupting
              chemicals, and stress-inducing lifestyle that Big Pharma's
              partners profit from.
            </p>
            <div className="bg-gray-200 p-6 rounded-lg mt-8" data-id="element-70">
              <p className="font-bold mb-2" data-id="element-71">Think about it:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-72">
                <li data-id="element-73">
                  Food companies sell you testosterone-killing processed junk
                </li>
                <li data-id="element-74">
                  Chemical companies flood your environment with hormone
                  disruptors
                </li>
                <li data-id="element-75">
                  Pharma companies then sell you expensive "treatments" for the
                  problems they helped create
                </li>
              </ul>
              <p className="mt-4 font-bold" data-id="element-76">It's the perfect crime.</p>
              <div className="mt-6 flex flex-col md:flex-row items-center gap-4 bg-gray-800 p-4 rounded-lg" data-id="element-77">
                <div className="md:w-1/4" data-id="element-78">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i7n1HjkJV7hZe3cdfgoPvA/1000001242.png" alt="247Alpha Supplement Bottle" className="w-24 h-auto mx-auto" data-id="element-79" />
                </div>
                <div className="md:w-3/4 text-center md:text-left" data-id="element-80">
                  <p className="text-blue-400 font-bold mb-2" data-id="element-81">
                    LIMITED TIME OFFER - 50% OFF
                  </p>
                  <a href="https://the247alpha.com/products/alpha-energy?variant=52325407719751" className="inline-block bg-blue-800 hover:bg-blue-900 text-white px-6 py-2 rounded-md font-medium transition duration-300 w-full md:w-auto text-center" data-id="element-82">
                    Fight Back Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-16" data-id="element-83">
            <h3 className="text-2xl font-bold mb-6 flex items-center" data-id="element-84">
              <DollarSignIcon className="mr-3 text-blue-600" size={28} data-id="element-85" />
              The $3 Billion Cover-Up
            </h3>
            <p className="mb-4" data-id="element-86">But here's where it gets really sinister...</p>
            <p className="mb-4" data-id="element-87">
              In 1987, researchers at MIT published a groundbreaking study on
              Eurycoma longifolia – that Malaysian root I mentioned.
            </p>
            <p className="mb-4" data-id="element-88">The results were staggering:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6" data-id="element-89">
              <li data-id="element-90">37% increase in free testosterone in just 12 weeks</li>
              <li data-id="element-91">61% reduction in stress hormones</li>
              <li data-id="element-92">Dramatic improvements in energy, strength, and libido</li>
            </ul>
            <p className="mb-4" data-id="element-93">Big Pharma took notice immediately.</p>
            <p className="mb-4" data-id="element-94">Not to develop it... but to bury it.</p>
            <p className="mb-4" data-id="element-95">
              Within 18 months, funding for Tongkat Ali research mysteriously
              dried up. The lead researcher was offered a lucrative position at
              a major pharmaceutical company – with one condition: he could
              never publish on natural testosterone boosters again.
            </p>
          </div>
          <div data-id="element-96">
            <h3 className="text-2xl font-bold mb-6 flex items-center" data-id="element-97">
              <TrendingDownIcon className="mr-3 text-blue-600" size={28} data-id="element-98" />
              Why Natural Terrifies Them
            </h3>
            <p className="mb-4" data-id="element-99">
              You see, Big Pharma's business model depends on three things:
            </p>
            <ol className="list-decimal pl-6 space-y-2 mb-6" data-id="element-100">
              <li data-id="element-101">Patentable synthetic compounds</li>
              <li data-id="element-102">Lifelong dependency</li>
              <li data-id="element-103">Managing symptoms, not curing problems</li>
            </ol>
            <p className="mb-4" data-id="element-104">
              A natural root that actually restores your body's ability to
              produce testosterone naturally? That's their worst nightmare.
            </p>
            <p className="mb-4" data-id="element-105">
              With Tongkat Ali and other traditional herbs, you don't become
              dependent. Your body learns to optimize its own hormone
              production. You get stronger, not weaker.
            </p>
            <p className="text-xl font-bold mb-4 text-center py-3" data-id="element-106">
              No monthly injections. No doctor visits. No insurance battles.
            </p>
            <p className="text-xl font-bold text-center mb-8" data-id="element-107">
              Just your masculine vitality... restored.
            </p>
            <div className="bg-gray-800 p-5 rounded-lg shadow-lg flex flex-col md:flex-row items-center gap-4" data-id="element-108">
              <div className="md:w-1/4" data-id="element-109">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i7n1HjkJV7hZe3cdfgoPvA/1000001242.png" alt="247Alpha Supplement Bottle" className="w-24 h-auto mx-auto" data-id="element-110" />
              </div>
              <div className="md:w-3/4 text-center md:text-left" data-id="element-111">
                <p className="text-blue-400 font-bold mb-2" data-id="element-112">
                  FOR A LIMITED TIME SAVE 50%
                </p>
                <a href="https://the247alpha.com/products/alpha-energy?variant=52325407719751" className="inline-block bg-blue-800 hover:bg-blue-900 text-white px-8 py-3 rounded-md font-bold transition duration-300 w-full md:w-auto text-center" data-id="element-113">
                  Get 247Alpha Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}